import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export type ReloadToastConfiguration = {
  inMeeting: boolean;
};

export type ReloadToastOpener = (config?: ReloadToastConfiguration) => Observable<boolean>;

export const RELOAD_TOAST = new InjectionToken<ReloadToastOpener>('RELOAD_TOAST', {
  providedIn: 'root',
  factory: (): ReloadToastOpener => (_?: ReloadToastConfiguration) => of(false),
});
